import React, { useState } from 'react';
import './BContact.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

// Recibimos la prop 'id' para que el scroll-to-section funcione.
function BContact({ id }) {
  
  // --- Lógica de React para manejar el formulario ---
  
  // Usamos un estado para todos los campos del formulario
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    position: '',
    phone: '',
    employees: '',
    industry: '',
    message: ''
  });

  // <<< INICIO DE NUEVA LÓGICA >>>
  // Añadimos un estado de 'carga' para deshabilitar el botón mientras se envía
  const [isLoading, setIsLoading] = useState(false);
  // <<< FIN DE NUEVA LÓGICA >>>


  // Función para actualizar el estado cuando el usuario escribe
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // <<< INICIO DE CIRUGÍA EN 'handleSubmit' >>>
  // Función que se ejecuta al enviar el formulario
  const handleSubmit = async (e) => { // 1. Convertimos la función a 'async'
    e.preventDefault(); // Prevenimos que la página se recargue
    setIsLoading(true); // 2. Activamos el estado de carga

    // 3. El endpoint del backend.
    //
    // ── POR QUÉ NO ES UNA DIRECCIÓN FIJA ─────────────────────────────────
    // Aquí estaba escrito `http://127.0.0.1:8000`, que es el ordenador de
    // quien programa. En producción ese formulario NO llegaba a ninguna
    // parte: quien pedía una demo desde /business se quedaba esperando una
    // llamada que nunca iba a existir. Ahora sale de la misma variable que
    // usa el resto de la aplicación.
    const BACKEND_URL = `${import.meta.env.VITE_API_URL || ''}/api/sales-advisor/contact`;

    try {
      // 4. Usamos 'fetch' para enviar los datos
      const response = await fetch(BACKEND_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Le decimos al backend que enviaremos JSON
        },
        body: JSON.stringify(formData), // 5. Convertimos nuestro objeto de React a un string JSON
      });

      // 6. Verificamos si la respuesta del backend NO fue exitosa
      if (!response.ok) {
        const errorData = await response.json(); // Intentamos leer el error
        throw new Error(errorData.detail || 'Error en el servidor. Intenta de nuevo.');
      }

      // 7. ¡ÉXITO! Si todo salió bien:
      // Mostramos la misma alerta que en el HTML original
      alert('¡Gracias por tu interés! Nos pondremos en contacto contigo en menos de 2 horas laborales para agendar tu demo personalizada.');
      
      // 8. Reseteamos el formulario
      setFormData({
        name: '',
        email: '',
        company: '',
        position: '',
        phone: '',
        employees: '',
        industry: '',
        message: ''
      });

    } catch (error) {
      // 9. MANEJO DE ERRORES (ej: el backend está caído o hay un error de red)
      console.error("Error al enviar el formulario:", error);
      alert(`Error: No se pudo enviar tu solicitud.\nPor favor, inténtalo más tarde o contáctanos por WhatsApp.\n\n(${error.message})`);
    
    } finally {
      // 10. Se ejecuta siempre (al éxito o al error)
      setIsLoading(false); // Desactivamos el estado de carga
    }
  };
  // <<< FIN DE CIRUGÍA EN 'handleSubmit' >>>


  // --- Funciones para los métodos de contacto (WhatsApp, Email, Tel) ---
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5215512345678', '_blank'); // (Reemplaza con tu número)
  };
  
  const handleEmailClick = () => {
    window.location.href = 'mailto:nsl.contacto@gmail.com'; // (Reemplaza con tu email)
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+525512345678'; // (Reemplaza con tu teléfono)
  };


  return (
    // 🩹 CIRUGÍA: Clase "contact-section" renombrada a "b-contact-section"
    <section className="b-contact-section" id={id || 'contact'}>
      <div className="container">
        <div className="contact-container">
          {/* ... (Todo el HTML/JSX de 'contact-info' se queda igual) ... */}
          <div className="contact-info">
            {/* ... (título, descripción, métodos de contacto) ... */}
              <h2 className="contact-title">¿Listo para transformar tu equipo?</h2>
              <p className="contact-description">
                Agenda una demo personalizada de 30 minutos y descubre cómo Non Stop Learning 
                puede acelerar las capacidades de inglés en tu empresa con nuestra solución 
                híbrida de IA + Profesores especializados.
              </p>
              <div className="contact-methods">
                <div className="contact-method" onClick={handleWhatsAppClick}>
                  <div className="contact-method-icon">💬</div>
                  <div className="contact-method-text">
                    <div className="contact-method-label">WhatsApp Business</div>
                    <div className="contact-method-value">Chat Directo (Respuesta en 5 min)</div>
                  </div>
                </div>
                <div className="contact-method" onClick={handleEmailClick}>
                  <div className="contact-method-icon">📧</div>
                  <div className="contact-method-text">
                    <div className="contact-method-label">Email Corporativo</div>
                    <div className="contact-method-value">nsl.contacto@gmail.com</div>
                  </div>
                </div>
                <div className="contact-method" onClick={handlePhoneClick}>
                  <div className="contact-method-icon">📞</div>
                  <div className="contact-method-text">
                    <div className="contact-method-label">Teléfono Directo</div>
                    <div className="contact-method-value">+52 55 1234 5678</div>
                  </div>
                </div>
              </div>
            </div>

          <div className="contact-form-container">
            {/* 🩹 CIRUGÍA: 'style' en línea eliminado y reemplazado por clase */}
            <h3 className="form-title">Solicita tu Demo Gratuita</h3>
            
            {/* Conectamos el formulario a la lógica de React */}
            <form id="contactForm" onSubmit={handleSubmit}>
              
              {/* ... (Todos los 'form-group' de los inputs se quedan igual) ... */}
              <div className="form-group">
                  <label className="form-label">Nombre Completo *</label>
                  <input 
                      maxLength={120}
                    type="text" 
                    className="form-input" 
                    placeholder="Juan Pérez" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Corporativo *</label>
                  <input 
                      maxLength={254}
                    type="email" 
                    className="form-input" 
                    placeholder="juan.perez@empresa.com" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Empresa *</label>
                  <input 
                      maxLength={120}
                    type="text" 
                    className="form-input" 
                    placeholder="Nombre de tu empresa" 
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Cargo/Posición *</label>
                  <input 
                      maxLength={120}
                    type="text" 
                    className="form-input" 
                    placeholder="Ej: Director de RH, CEO" 
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono con WhatsApp *</label>
                  <input 
                    type="tel" 
                    className="form-input" 
                    placeholder="+52 55 1234 5678" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Número de Empleados a Capacitar *</label>
                  <select 
                    className="form-select" 
                    name="employees"
                    value={formData.employees}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona un rango</option>
                    <option value="1-10">1-10 empleados</option>
                    <option value="11-50">11-50 empleados</option>
                    <option value="51-100">51-100 empleados</option>
                    <option value="101-500">101-500 empleados</option>
                    <option value="500+">500+ empleados</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Industria/Sector</label>
                  <select 
                    className="form-select"
                    name="industry"
                    value={formData.industry}
                    onChange={handleChange}
                  >
                    <option value="">Selecciona tu industria</option>
                    <option value="tech">Tecnología y Software</option>
                    <option value="finance">Finanzas y Banca</option>
                    <option value="retail">Retail y E-commerce</option>
                    <option value="hospitality">Restaurantes y Hotelería</option>
                    <option value="healthcare">Salud y Bienestar</option>
                    <option value="other">Otra</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">¿Qué te gustaría lograr con tu equipo?</label>
                  <textarea 
                      maxLength={1200}
                    className="form-textarea" 
                    placeholder="Ej: Necesitamos que nuestro equipo de ventas cierre deals con clientes en USA..."
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
              
              {/* <<< INICIO DE CIRUGÍA EN EL BOTÓN >>> */}
              <button 
                type="submit" 
                className="form-submit" 
                disabled={isLoading} 
              >
                {isLoading ? 'Enviando...' : 'Agendar Demo Gratuita 🚀'}
              </button>
              {/* <<< FIN DE CIRUGÍA EN EL BOTÓN >>> */}

              {/* 🩹 CIRUGÍA: 'style' en línea eliminado y reemplazado por clase */}
              <p className="form-footer-notes">
                ✓ Respuesta en menos de 2 horas laborales<br />
                ✓ Demo personalizada de 30 minutos<br />
                ✓ Propuesta comercial el mismo día
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BContact;
